import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MailFavoritesStore" */ './lazyIndex'),
    { name: 'MailFavoritesStore' }
);

export const lazyToggleFavoritesTreeExpansion: LazyAction<
    typeof lazyIndex.toggleFavoritesTreeExpansion,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.toggleFavoritesTreeExpansion);

export const lazyRemoveFavoritePersona: LazyAction<
    typeof lazyIndex.removeFavoritePersona,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.removeFavoritePersona);

export const lazyOnSelectedPersonaNodeChanged: LazyAction<
    typeof lazyIndex.onSelectedPersonaNodeChanged,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onSelectedPersonaNodeChanged);

export const lazyHandleToggleFavoritePersonaError: LazyAction<
    typeof lazyIndex.handleToggleFavoritePersonaError,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.handleToggleFavoritePersonaError);

export const lazyAddFavoriteFolder: LazyImport<
    typeof lazyIndex.addFavoriteFolder,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.addFavoriteFolder);
export const lazyRemoveFavoriteFolder: LazyImport<
    typeof lazyIndex.removeFavoriteFolder,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.removeFavoriteFolder);

export const lazyAddFavoritePersona: LazyAction<
    typeof lazyIndex.addFavoritePersona,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addFavoritePersona);
export const lazyOutlookFavoritePersonasLoaded: LazyAction<
    typeof lazyIndex.outlookFavoritePersonasLoaded,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.outlookFavoritePersonasLoaded);

export const lazyOutlookFavoriteFoldersLoaded: LazyAction<
    typeof lazyIndex.outlookFavoriteFoldersLoaded,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.outlookFavoriteFoldersLoaded);

export const lazyInitializeFavoriteNodeViewState: LazyAction<
    typeof lazyIndex.initializeFavoriteNodeViewState,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeFavoriteNodeViewState);

export const lazyShowFindFavoritesPicker: LazyAction<
    typeof lazyIndex.showFindFavoritesPicker,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.showFindFavoritesPicker);
